import { render } from "./ReviewSentRequestPage.vue?vue&type=template&id=4b87ee07&scoped=true&ts=true"
import script from "./ReviewSentRequestPage.vue?vue&type=script&lang=ts"
export * from "./ReviewSentRequestPage.vue?vue&type=script&lang=ts"

import "./ReviewSentRequestPage.vue?vue&type=style&index=0&id=4b87ee07&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b87ee07"]])

export default __exports__